export const PALETTE = {
  primary: '#29b194',
  primaryDark: '#19857b',
  blue: '#4a90d9',
  amber: '#e0a92e',
  danger: '#e2705f',
  axis: '#9aa8a4',
  grid: '#eef2f1',
  ink: '#1f2a28',
  muted: '#7a8a86',
} as const;

// choropleth low → high
export const GEO_SCALE = ['#e8f6f2', '#7fd4c0', '#29b194', '#146b5c'] as const;
